/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnRightUpIcon32Regular = forwardRef('ArrowDUturnRightUpIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M31.23 12.316a1 1 0 1 1-1.46 1.368L24 7.529V17.5C24 23.3 19.299 28 13.5 28S3 23.3 3 17.5V10a1 1 0 1 1 2 0v7.5a8.5 8.5 0 0 0 17 0V7.53l-5.77 6.155a1 1 0 1 1-1.46-1.368l6.041-6.444a3 3 0 0 1 4.378 0l6.04 6.444Z" })));
});
